import useContext from "../../../context";
import { getApplicationThankYouUrl } from "../../../config";
import { findResort } from "../../../loanConfig";

export default function HiddenFields() {
  const [context] = useContext();
  const applicationThankYouUrl = getApplicationThankYouUrl();

  const loan = context.response[context.loanOption];
  const resort = findResort(context.config.resorts, context.resort);

  const isRefinance = context.contractType === 'refinance';

  const details = [];

  for (const item of loan.estimated_cash_details) {
    details.push(item);

    if (item.subItems) {
      details.push(...item.subItems);
    }
  }

  // Fee keys can carry a state suffix (e.g. mortgage_recording_fees_fl), so match by prefix
  function getValue(keyPrefix) {
    const detail = details.find(({ key }) => key && key.startsWith(keyPrefix));

    return detail ? detail.value : "";
  }

  function getValueByLabel(pattern) {
    const detail = details.find(({ label }) => pattern.test(label));

    return detail ? detail.value : "";
  }

  return (
    <React.Fragment>
      <input type="hidden" name="referral-code" value={sessionStorage.getItem('referral_code')} />
      <input type="hidden" name="purchase-price" value={loan.purchase_price} />
      <input type="hidden" name="down-payment" value={getValue('downpayment')} />
      <input type="hidden" name="monthly-payment" value={loan.monthly_payment} />
      <input type="hidden" name="cash-close" value={loan.estimated_cash_to_close} />
      <input type="hidden" name="broker-deposit" value={getValue('escrowdeposit')} />
      <input type="hidden" name="contract" value={context.contractType} />
      <input type="hidden" name="resort" value={context.resort} />
      <input type="hidden" name="resort-code" value={resort ? resort.code : ''} />
      <input type="hidden" name="loan-option" value={loan.loan_option || (context.loanOption === 'creditCheck' ? 'FICO' : ['A', 'B', 'C'][context.downPaymentOption - 1])} />
      <input type="hidden" name="closing-cost-responsibility" value={context.sellerPaysClosingCosts ? 'seller' : 'buyer'} />
      <input type="hidden" name="points" value={context.totalPoints} />
      <input type="hidden" name="financing-closing" value={context.financeClosingCosts ? 'yes' : 'no'} />
      <input type="hidden" name="financing-closing-amount" value={loan.financed_closing_costs || getValue('closing_costs_financed')} />

      <input type="hidden" name="loan-origination" value={getValue('loan_origination_fee')} />
      <input type="hidden" name="mortgage-recording" value={getValue('mortgage_recording')} />
      <input type="hidden" name="annual-dues" value={getValue('annualdues')} />
      <input type="hidden" name="lender-policy-fees" value={getValue('lender_s_title_policy')} />
      <input type="hidden" name="mortgage-tax" value={getValueByLabel(/mortgage tax stamps/i)} />
      <input type="hidden" name="closing-costs" value={getValue('title_company_closing_costs')} />
      <input type="hidden" name="price-per-point" value={context.pricePerPoint} />
      {context.loanOption === 'creditCheck' && (
      <input type="hidden" name="credit-rating" value={context.creditRating} />
      )}
      <input type="hidden" name="loan-amount" value={loan.total_loan_amount} />
      <input type="hidden" name="loan-options" value={
        isRefinance
          ? loan.refinance_options
          : loan.down_payment_options.map((dp) => loan.purchase_price - dp)
      } />
      <input type="hidden" name="down-payment-options" value={JSON.stringify(loan.down_payment_options)} />
      <input type="hidden" name="loan-term" value={loan.loan_term} />
      <input type="hidden" name="loan-interest-rate" value={loan.interest_rate} />
      {applicationThankYouUrl && (
        <input type="hidden" name="thank-you-url" value={applicationThankYouUrl} />
      )}
      <input type="hidden" name="form-action" value="quote" />
      <input type="hidden" name="_wpnonce" value="" />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/HiddenFields.js